export interface CustomIcon {
  svg: string;
  path: string;
}

export const IconLibrary: CustomIcon[] = [
  { svg: 'adTest', path: 'assets/icon/svg/icon-adTest.svg' },
  { svg: 'allParticipants', path: 'assets/icon/svg/icon-allParticipants.svg' },
  { svg: 'blue-bg-pen-ruler', path: 'assets/icon/svg/icon-blue-bg-pen-ruler.svg' },
  { svg: 'brandTracker', path: 'assets/icon/svg/icon-brandTracker.svg' },
  { svg: 'challenging', path: 'assets/icon/svg/ai-tones/icon-challenging.svg' },
  { svg: 'clients', path: 'assets/icon/svg/icon-clients.svg' },
  { svg: 'clipboard-user', path: 'assets/icon/svg/icon-clipboard-user.svg' },
  { svg: 'comment-lines', path: 'assets/icon/svg/icon-comment-lines.svg' },
  { svg: 'competitorAnalysis', path: 'assets/icon/svg/icon-competitorAnalysis.svg' },
  { svg: 'conceptTest', path: 'assets/icon/svg/icon-conceptTest.svg' },
  { svg: 'dailypolls', path: 'assets/icon/svg/icon-dailypolls.svg' },
  { svg: 'completions', path: 'assets/icon/svg/icon-completions.svg' },
  { svg: 'crosstabs', path: 'assets/icon/svg/icon-crosstabs.svg' },
  { svg: 'deepsights', path: 'assets/icon/svg/icon-deepsights.svg' },
  { svg: 'dropouts', path: 'assets/icon/svg/icon-dropouts.svg' },
  { svg: 'empathetic', path: 'assets/icon/svg/ai-tones/icon-empathetic.svg' },
  { svg: 'formal', path: 'assets/icon/svg/ai-tones/icon-formal.svg' },
  { svg: 'flagged', path: 'assets/icon/svg/icon-flagged.svg' },
  { svg: 'friendly', path: 'assets/icon/svg/ai-tones/icon-friendly.svg' },
  { svg: 'gray-bg-clone', path: 'assets/icon/svg/icon-gray-bg-clone.svg' },
  { svg: 'submission-green', path: 'assets/icon/svg/icon-green-submission.svg' },
  { svg: 'hidden-insights', path: 'assets/icon/svg/icon-hidden-insights.svg' },
  { svg: 'home', path: 'assets/icon/svg/icon-home.svg' },
  { svg: 'humorous', path: 'assets/icon/svg/ai-tones/icon-humorous.svg' },
  { svg: 'logout', path: 'assets/icon/svg/icon-logout.svg' },
  { svg: 'neutral', path: 'assets/icon/svg/ai-tones/icon-neutral.svg' },
  { svg: 'nps', path: 'assets/icon/svg/icon-nps.svg' },
  { svg: 'onlineListening', path: 'assets/icon/svg/icon-onlineListerning.svg' },
  { svg: 'overview', path: 'assets/icon/svg/icon-overview.svg' },
  { svg: 'panelistmanager', path: 'assets/icon/svg/icon-panelistmanager.svg' },
  { svg: 'prizeDrawParticipants', path: 'assets/icon/svg/icon-prizeDrawParticipants.svg' },
  { svg: 'productTest', path: 'assets/icon/svg/icon-productTest.svg' },
  { svg: 'profiling', path: 'assets/icon/svg/icon-profiling.svg' },
  { svg: 'participants', path: 'assets/icon/svg/icon-participants.svg' },
  { svg: 'projects', path: 'assets/icon/svg/icon-projects.svg' },
  { svg: 'pulse', path: 'assets/icon/svg/icon-pulse.svg' },
  { svg: 'purple-bg-sparkle', path: 'assets/icon/svg/icon-purple-bg-sparkle.svg' },
  { svg: 'purple-bg-user-magnifying-glass', path: 'assets/icon/svg/icon-purple-bg-user-magnifying-glass.svg' },
  { svg: 'qualitative-research', path: 'assets/icon/svg/icon-qualitative-research.svg' },
  { svg: 'quantitative-research', path: 'assets/icon/svg/icon-quantitative-research.svg' },
  { svg: 'quotas', path: 'assets/icon/svg/icon-quotas.svg' },
  { svg: 'registrations', path: 'assets/icon/svg/icon-registrations.svg' },
  { svg: 'reports', path: 'assets/icon/svg/icon-reports.svg' },
  { svg: 'research-method-ai-interview', path: 'assets/icon/svg/icon-research-method-ai-interview.svg' },
  { svg: 'research-method-discussion-forum', path: 'assets/icon/svg/icon-research-method-discussion-forum.svg' },
  { svg: 'research-method-survey', path: 'assets/icon/svg/icon-research-method-survey.svg' },
  { svg: 'research-method-external-survey', path: 'assets/icon/svg/icon-research-method-external-survey.svg' },
  { svg: 'reverseLeft', path: 'assets/icon/svg/icon-reverse-left.svg' },
  { svg: 'rewards', path: 'assets/icon/svg/icon-rewards.svg' },
  { svg: 'subpanels', path: 'assets/icon/svg/icon-subpanels.svg' },
  { svg: 'settings', path: 'assets/icon/svg/icon-settings.svg' },
  { svg: 'success-bg-circle-check', path: 'assets/icon/svg/icon-success-bg-circle-check.svg' },
  { svg: 'success-bg-folder-arrow-up', path: 'assets/icon/svg/icon-success-bg-folder-arrow-up.svg' },
  { svg: 'success-bg-user-group-simple', path: 'assets/icon/svg/icon-success-bg-user-group-simple.svg' },
  { svg: 'selectorVertical', path: 'assets/icon/svg/icon-selector-vertical.svg' },
  { svg: 'shield', path: 'assets/icon/svg/icon-shield.svg' },
  { svg: 'squareQuestion', path: 'assets/icon/svg/icon-square-question.svg' },
  { svg: 'summary', path: 'assets/icon/svg/icon-summary.svg' },
  { svg: 'userpen', path: 'assets/icon/svg/icon-userpen.svg' },
  { svg: 'terminates', path: 'assets/icon/svg/icon-terminates.svg' },
  { svg: 'alert-bg-circle-close', path: 'assets/icon/svg/icon-alert-bg-circle-close.svg' },
  { svg: 'warning-bg-circle-close', path: 'assets/icon/svg/icon-warning-bg-circle-close.svg' },
  { svg: 'disabled-bg-circle-close', path: 'assets/icon/svg/icon-disabled-bg-circle-close.svg' },
  { svg: 'yellow-bg-upload-arrow-up', path: 'assets/icon/svg/icon-yellow-bg-upload-arrow-up.svg' },
  { svg: 'yellow-bg-user-magnifying-glass', path: 'assets/icon/svg/icon-yellow-bg-user-magnifying-glass.svg' },
  { svg: 'yellow-bg-memo-pad', path: 'assets/icon/svg/icon-yellow-bg-memo-pad.svg' }
];
